// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__6Q+GV","links":"Footer_links__eKPxo","copyright":"Footer_copyright__oFFky"};